<script>
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";

  import { candidateStore } from "../stores";
  import { convertToInmail } from "./utils";

  $: disabled = !$candidateStore.linkedinUrl;
  const onclick = async () => {
    if (disabled) return;

    await convertToInmail();
  };
</script>

<ButtonWithTooltip
  kind="secondary"
  leadingIcon="fab fa-linkedin"
  class="flex-1 {disabled ? 'disabled' : ''}"
  placement="top"
  {onclick}
  size="large"
>
  <span slot="tooltip">
    {#if disabled}
      Missing LinkedIn URL, edit contact details to convert to InMail.
    {:else}
      Add contact to campaign with email steps replaced by InMail steps.
    {/if}
  </span>
  Convert to InMail
</ButtonWithTooltip>
